import Splide from "@splidejs/splide";

class LylePreHeaderBanner extends HTMLElement {
  #splide = null;

  connectedCallback() {
    if (this.classList.contains("pre-header-banner--stack")) {
      this.classList.add("is-rendered");
      return;
    }

    const autoplay = this.dataset.autoplay !== "false";
    const interval = Number.parseInt(this.dataset.autoplaySpeed, 10) || 2500;

    const splide = new Splide(this, {
      autoplay,
      interval,
      arrows: false,
      pagination: false,
      rewind: true,
      type: "fade",
    });

    splide.mount();
    this.#splide = splide;
  }

  disconnectedCallback() {
    this.#splide?.destroy();
    this.#splide = null;
  }
}

if (!customElements.get("lyle-pre-header-banner")) {
  customElements.define("lyle-pre-header-banner", LylePreHeaderBanner);
}
